import React from 'react';
import { Link, NavLink, useLocation, useNavigation } from 'react-router-dom';
import logo from '../../assets/img/credibled_logo_205x45.png';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import { CircularProgress } from '@mui/material';

const UserLayout = () => {
	const currLink = useLocation().pathname;
	const baseLink = currLink.split('/')[1];
	const { state, location } = useNavigation();
	return (
		<>
			<div
				className='sidebar'
				data-color='purple'
				data-background-color='white'
			>
				<div className='logo text-center'>
					<Link
						className='navbar-brand'
						to='requests'
					>
						<img
							src={logo}
							alt='Credibled Logo'
							style={{ height: '43px' }}
						/>
					</Link>
					<h4 className='text-secondary'>Client User</h4>
				</div>
				<div className='sidebar-wrapper'>
					<ul className='nav'>
						<li className='nav-item'>
							<Link
								className='nav-link or_bg'
								to={`add-new-request`}
							>
								<i className='material-icons txt_white'>post_add</i>
								<span className='new_req'>New </span>
								<span className='new_req'>request</span>
							</Link>
						</li>
						<li
							className={`nav-item ${
								currLink.includes('requests') ? 'active' : null
							}`}
						>
							<Link
								className={`nav-link ${
									currLink.includes('requests') ? 'active1' : null
								}`}
								to={`/${baseLink}/requests`}
							>
								<i className='material-icons'>dvr</i>
								<p>Reference Check</p>
							</Link>
						</li>
						<li
							className={`transition-all nav-item ${
								currLink.includes('background-check') ? 'active' : null
							}`}
						>
							<NavLink
								className={({ isActive }) =>
									` nav-link ${isActive && 'active1'}`
								}
								to='background-check'
							>
								<i className='material-icons'>
									<WorkHistoryIcon />
								</i>
								<p>
									background check{' '}
									{state === 'loading' &&
										location.pathname.includes('background-check') && (
											<CircularProgress
												size={15}
												className='ml-3'
												color='inherit'
												sx={{ color: '#ed642b' }}
											/>
										)}
								</p>
							</NavLink>
						</li>
						<li
							className={`nav-item ${
								currLink.includes('questionnaires') ? 'active' : null
							}`}
						>
							<NavLink
								className={({ isActive }) =>
									`nav-link ${isActive && 'active1'}`
								}
								to={`/${baseLink}/questionnaires`}
							>
								<i className='material-icons-outlined'>assignment</i>
								<p>Questionnaires</p>
							</NavLink>
						</li>
						<li
							className={`nav-item ${
								currLink.includes('template-homepage') ? 'active' : null
							}`}
						>
							<NavLink
								className={({ isActive }) =>
									`nav-link ${isActive && 'active1'}`
								}
								to={`/home/template-homepage`}
							>
								<i className='material-icons-outlined'>view_list</i>
								<p>Questionnaire Builder</p>
							</NavLink>
						</li>
						<li
							className={`nav-item ${
								currLink.includes('settings') && 'active'
							}`}
						>
							<Link
								className={`nav-link ${
									currLink.includes('settings') && 'active1'
								}`}
								to={`/${baseLink}/settings`}
							>
								<i className='material-icons-outlined'>settings</i>
								<p>settings</p>
							</Link>
						</li>
					</ul>
					<div className='tile_side'>
						<label className='h4'>
							Credits&nbsp;
							<Link
								to='/buy-credits'
								className='fw300sm'
							>
								Buy Now!
							</Link>
						</label>
						<div className='h1 d-flex justify-content-between'>
							<span className='text-secondary material-icons-outlined'>
								account_balance
							</span>
							<label>10</label>
						</div>
					</div>
					<div className='teaser-box'>
						<div className='teaser_img'>
							<img
								src='assets/img/ref-img.png'
								width='100%'
								alt=''
							/>
							<h4>
								Before you hire
								<br />
								Check with here!
							</h4>
							<p>
								{' '}
								Automate your employment reference checking process. CREDIBLED
								checking platform...{' '}
							</p>
							<p className='text-right'>
								<Link to='#'>Read more</Link>
							</p>
						</div>
					</div>
				</div>
			</div>
			<footer
				className='footer showonmobile'
				style={{ display: `none` }}
			>
				<nav className='col-md-12'>
					<ul className='mobile_footer'>
						<li
							className={`nav-item ${
								currLink.includes('add-new-request') ? 'mobile-active' : null
							}`}
						>
							<Link
								className='nav-link'
								to={`add-new-request`}
							>
								<i className='material-icons-outlined'>post_add</i>
								<p>New Request</p>
							</Link>
						</li>
						<li className='nav-item'>
							<Link
								className={`nav-item ${
									currLink.includes('requests') &&
									!currLink.includes('add-new-request')
										? 'mobile-active'
										: null
								}`}
								to='/home/requests'
							>
								<i className='material-icons-outlined'>dvr</i>
								<p>Reference Check</p>
							</Link>
						</li>
						<li
							className={`nav-item ${
								currLink.includes('background-check') ? 'mobile-active' : null
							}`}
						>
							<Link
								className='nav-link'
								to='background-check'
							>
								<i className='material-icons-outlined'>shield</i>
								<p>Background Check</p>
							</Link>
						</li>
						<li className='nav-item dropdown'>
							<a
								className='nav-link'
								href='#!'
								id='footermore'
								data-toggle='dropdown'
								aria-haspopup='true'
								aria-expanded='false'
							>
								<i className='material-icons-outlined'>more_vert</i>
								<p>More</p>
							</a>
							<div
								className='dropdown-menu'
								aria-labelledby='navbarDropdownMenuLink'
							>
								<Link
									className='dropdown-item'
									to={`/${baseLink}/questionnaires`}
								>
									Questionnaires
								</Link>
								<Link
									className='dropdown-item'
									to={`/home/template-homepage`}
								>
									Questionnaire Builder
								</Link>
								<Link
									className='dropdown-item'
									to={`/${baseLink}/settings`}
								>
									Settings
								</Link>
							</div>
						</li>
					</ul>
				</nav>
			</footer>
		</>
	);
};

export default UserLayout;
